if (!customElements.get('loyalty-signup')) {
  class LoyaltySignup extends HTMLElement {
    constructor() { 
      super();
      console.log('LoyaltySignup Connected');
      // this.customerEmail = 'ahmed@pacer.studio';
      this.error = null;
      this.customerEmail = this.dataset.customerEmail;
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.dob = this.querySelector('input[name="dob"]');
      this.userMessage = this.querySelector('.user-message');
      this.birthdayTitle = this.querySelector('.birthday-title');
      this.birthdaySuccessTitle = this.querySelector('.birthday-success-title');
      this.birthdayDescription = this.querySelector('.birthday-description');
      this.birthdaySuccessDescription = this.querySelector('.birthday-success-description');
      this.loyaltyTitle = this.querySelector('.loyalty-title');
      this.successTitle = this.querySelector('.success-title');
      this.loyaltyDescription = this.querySelector('.loyalty-description');
      this.successDescription = this.querySelector('.success-description');
      this.customerIsinactive = false;
      this.customerNoDob = false;
      this.buttonText = this.submitButton.querySelector('.text');
      

      // Form validation elements
      this.firstNameInput = this.querySelector('input[name="first_name"]');
      this.lastNameInput = this.querySelector('input[name="last_name"]');
      this.emailInput = this.querySelector('input[name="email"]');
      this.firstNameError = this.querySelector('#first_name_error');
      this.lastNameError = this.querySelector('#last_name_error');
      this.emailError = this.querySelector('#email_error');
      this.dobError = this.querySelector('#dob_error');
      this.acceptTermsInput = this.querySelector('input[name="accept_terms"]');
      this.acceptTermsError = this.querySelector('#accept_terms_error');

      this.initAuxField();
      this.checkCustomerStatus();

      // Validation state
      this.validationState = {
        firstName: false,
        lastName: false,
        email: false
      };

      this.setupEventListeners();
    }

    setupEventListeners() {
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      } else if (this.submitButton) {
        // Fallback: should not happen, but prevents a broken CTA if markup changes
        this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
      }

      if (this.dob) {
        this.dob.addEventListener('change', this.checkifOver16.bind(this));
      }

      // Real-time validation event listeners
      if (this.firstNameInput && !this.firstNameInput.disabled) {
        this.firstNameInput.addEventListener('blur', () => this.validateFirstName());
        this.firstNameInput.addEventListener('input', () => this.clearFieldError('firstName'));
      }

      if (this.lastNameInput && !this.lastNameInput.disabled) {
        this.lastNameInput.addEventListener('blur', () => this.validateLastName());
        this.lastNameInput.addEventListener('input', () => this.clearFieldError('lastName'));
      }

      if (this.emailInput && !this.emailInput.disabled) {
        this.emailInput.addEventListener('blur', () => this.validateEmail());
        this.emailInput.addEventListener('input', () => this.clearFieldError('email'));
      }

    }

    generateRandomToken(length = 16) {
      try {
        const bytes = new Uint8Array(length);
        window.crypto.getRandomValues(bytes);
        return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('').slice(0, length);
      } catch (e) {
        // Fallback: best-effort
        return Math.random().toString(36).slice(2, 2 + length);
      }
    }

    initAuxField() {
      // Markup is present in Liquid, but if it ever isn't, we create it.
      let input = this.querySelector('[data-lybc-aux]');
      let label = this.querySelector('[data-lybc-aux-label]');

      if (!input) {
        const container = document.createElement('div');
        container.className = 'from-row lybc-aux';
        container.setAttribute('aria-hidden', 'true');

        const fieldGroup = document.createElement('div');
        fieldGroup.className = 'field-group';

        label = document.createElement('label');
        label.setAttribute('data-lybc-aux-label', '');

        input = document.createElement('input');
        input.setAttribute('data-lybc-aux', '');
        input.type = 'text';
        input.name = '';
        input.id = '';
        input.value = '';
        input.tabIndex = -1;
        input.autocomplete = 'off';

        fieldGroup.appendChild(label);
        fieldGroup.appendChild(input);
        container.appendChild(fieldGroup);

        if (this.form) {
          this.form.prepend(container);
        } else {
          this.prepend(container);
        }
      }

      // Dynamic/random name + id on each page load
      const token = this.generateRandomToken(12);
      const randomName = `tbs_${token}`;
      const randomId = `tbs_${token}_id`;

      input.name = randomName;
      input.id = randomId;
      input.value = '';
      input.setAttribute('aria-hidden', 'true');
      input.setAttribute('autocapitalize', 'off');
      input.setAttribute('spellcheck', 'false');
      input.setAttribute('inputmode', 'text');

      if (label) {
        label.htmlFor = randomId;
        label.textContent = `leave_blank_${this.generateRandomToken(8)}`;
      }
    }

    isAuxFieldFilled() {
      const input = this.querySelector('[data-lybc-aux]');
      if (!input) return false;
      return String(input.value || '').trim().length > 0;
    }

    saveToLocalStorage(email) {
      try {
        localStorage.setItem('loyalty_signup_email', email);
        localStorage.setItem('form_is_submitted', true);
        localStorage.setItem('first_name', this.firstNameInput.value);
        localStorage.setItem('last_name', this.lastNameInput.value);
      } catch (error) {
        console.error('Error saving to local storage:', error);
      }
    }

    pushLYBCRegistrationEvent() {
      try {
        
        const urlParams = new URLSearchParams(window.location.search);

        const eventData = {
          event: 'lybcRegistrationComplete',
          reg_channel: urlParams.get('reg_channel') ?? undefined,
          store_id: urlParams.get('store_id') ?? undefined,
          utm_source: urlParams.get('utm_source') ?? undefined,
          utm_campaign: urlParams.get('utm_campaign') ?? undefined
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventData);

      } catch (error) {
        console.error('[LYBC] Error pushing GTM event:', error);
      }
    }

    // Validation helper methods
    validateFirstName() {
      const value = this.firstNameInput.value.trim();
      const isValid = this.validateName(value, 'First name');
      
      if (isValid) {
        this.setFieldValid('firstName', this.firstNameInput, this.firstNameError);
      } else {
        this.setFieldError('firstName', this.firstNameInput, this.firstNameError, this.getNameErrorMessage(value, 'First name'));
      }
      
      return isValid;
    }

    validateLastName() {
      const value = this.lastNameInput.value.trim();
      const isValid = this.validateName(value, 'Last name');
      
      if (isValid) {
        this.setFieldValid('lastName', this.lastNameInput, this.lastNameError);
      } else {
        this.setFieldError('lastName', this.lastNameInput, this.lastNameError, this.getNameErrorMessage(value, 'Last name'));
      }
      
      return isValid;
    }

    validateEmail() {
      const value = this.emailInput.value.trim();
      const isValid = this.isValidEmail(value);
      
      if (isValid) {
        this.setFieldValid('email', this.emailInput, this.emailError);
      } else {
        this.setFieldError('email', this.emailInput, this.emailError, this.getEmailErrorMessage(value));
      }
      
      return isValid;
    }

    // Core validation logic
    validateName(value, fieldName) {
      if (!value) return false;
      if (value.length < 2) return false;
      if (value.length > 50) return false;
      // Allow letters, spaces, hyphens, and apostrophes
      const nameRegex = /^[a-zA-Z\s\-']+$/;
      return nameRegex.test(value);
    }

    isValidEmail(email) {
      if (!email) return false;
      // Comprehensive email regex
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      return emailRegex.test(email) && email.length <= 254;
    }

    // Error message generators
    getNameErrorMessage(value, fieldName) {
      if (!value) {
        return `${fieldName} is required`;
      }
      if (value.length < 2) {
        return `${fieldName} must be at least 2 characters long`;
      }
      if (value.length > 50) {
        return `${fieldName} must be less than 50 characters`;
      }
      return `${fieldName} contains invalid characters`;
    }

    getEmailErrorMessage(value) {
      if (!value) {
        return 'Email is required';
      }
      if (value.length > 254) {
        return 'Email is too long';
      }
      return 'Please enter a valid email address';
    }

    // UI state management
    setFieldError(fieldKey, inputElement, errorElement, message) {
      this.validationState[fieldKey] = false;
      inputElement.classList.add('error');
      inputElement.classList.remove('valid');
      if (errorElement) {
        errorElement.textContent = message;
      }
    }

    setFieldValid(fieldKey, inputElement, errorElement) {
      this.validationState[fieldKey] = true;
      inputElement.classList.add('valid');
      inputElement.classList.remove('error');
      if (errorElement) {
        errorElement.textContent = '';
      }
    }

    clearFieldError(fieldKey) {
      const inputElement = fieldKey === 'firstName' ? this.firstNameInput : 
                          fieldKey === 'lastName' ? this.lastNameInput : this.emailInput;
      const errorElement = fieldKey === 'firstName' ? this.firstNameError : 
                          fieldKey === 'lastName' ? this.lastNameError : this.emailError;
      
      inputElement.classList.remove('error', 'valid');
      if (errorElement) {
        errorElement.textContent = '';
      }
    }

    // Form validation
    validateForm() {
      let isValid = true;

      // Only validate enabled fields
      if (this.firstNameInput && !this.firstNameInput.disabled) {
        if (!this.validateFirstName()) isValid = false;
      }

      if (this.lastNameInput && !this.lastNameInput.disabled) {
        if (!this.validateLastName()) isValid = false;
      }

      if (this.emailInput && !this.emailInput.disabled) {
        if (!this.validateEmail()) isValid = false;
      }

      return isValid;
    }

    async handleSubmit(event) {
      event.preventDefault();

      // Validate auxiliary field
      if (this.isAuxFieldFilled()) {
        if (this.userMessage) {
          this.userMessage.textContent = 'Something went wrong. Please try again.';
        }
        if (this.submitButton) {
          this.submitButton.disabled = true;
        }
        return;
      }

      if (!this.validateForm()) return;
      const email = this.querySelector('input[name="email"]').value;
      const fetchCustomerInfo = await this.fetchCustomerInfo(email);
      if(this.error || !fetchCustomerInfo) {
        this.createNewCustomer(email);
        console.log('Error', this.error);
      } else {
        if (this.customerNoDob) {
          this.updateCustomerInfo(email);
          return;
        }
        // Existing customer / duplicate email case
        this.loyaltyTitle.innerHTML = 'You’re already a member! <a href="/account">Login here.</a>';
        this.userMessage.textContent = 'This email is already registered, please login to the store';
        this.submitButton.disabled = true;
      }
    }

    checkifOver16() {
      const dob = this.dob.value;
      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const month = today.getMonth() - birthDate.getMonth();
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      if(age >= 16 || !dob) {
        this.submitButton.disabled = false;
        this.dobError.textContent = '';
      } else {
        this.submitButton.disabled = true;
        this.dobError.textContent = 'You must be 16 years old to receive birthday rewards';
      }
    }

    async  hashData(str) {
      // 1. Encode the string into a Uint8Array
      const data = new TextEncoder().encode(str);
      
      // 2. Hash the data using the SubtleCrypto API
      const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);

      // 3. Convert the ArrayBuffer to a hexadecimal string
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
      
      return hashHex;
    }

    // Date conversion helper
    convertDateFormat(dateString) {
      if (!dateString) return '';
      
      // Check if date is already in yyyy-mm-dd format
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
      }
      
      // Check if date is in dd/mm/yyyy format
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        const [day, month, year] = dateString.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
      
      // If it's neither format, try to parse as Date and convert
      try {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return date.toISOString().split('T')[0];
        }
      } catch (error) {
        console.warn('Invalid date format:', dateString);
      }
      
      return dateString; // Return original if conversion fails
    }

    async fetchCustomerInfo(email) {
      if (!email) {
        return;
      }
      this.error = null;
      let data;
      const body = {
        email: email,
      };

      const payloadString = JSON.stringify(body);
      const payloadHash = await this.hashData(payloadString);
    
      this.setApiLoading = true;
      let url = 'https://azsu-rg-integration-qa-func-talon.azurewebsites.net/api/pdp-customer-info?code=P2lX5NUxGMJK-pI4oX2MhDF9kVYZkv1dB4TxRSvwXqfJAzFuNKvuVQ==';
      if(Shopify.shop === 'the-body-shop-uk.myshopify.com') {
        url = 'https://azsu-integration-prod-apim-ecomm.azure-api.net/azsu-int-prod-func-talon-pdp/pdp-customer-info';
      }
    
      try { 
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-App-Access-Token': payloadHash 
          },
          body: payloadString
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        data = await response.json();
      } catch (error) {
        this.error = error;
        console.error('There was a problem with the fetch operation:', error);
      } finally {
        this.setApiLoading = false;
      }
      return data;
    }


    async createNewCustomer(email) {
      const dob = this.querySelector('input[name="dob"]')?.value;
      const firstName = this.querySelector('input[name="first_name"]')?.value;
      const lastName = this.querySelector('input[name="last_name"]')?.value;
      this.submitButton.disabled = true;
      this.buttonText.classList.add('is-hidden');
      this.submitButton.classList.add('loading');

      const body = {
        "FirstName" : firstName,
        "LastName" : lastName,
        "Phone" : "",
        "Email" : email,      
        "DateOfBirth": this.convertDateFormat(dob),
        "LYBC": {
          "Active": "true",
          "TermsAcceptedDate": new Date().toISOString().split('T')[0],
          "SignUpDate": new Date().toISOString().split('T')[0]
        },
        "PostalConsent": false,
        "SmsConsent": false, 
        "EmailConsent": this.acceptTermsInput ? this.acceptTermsInput.checked : false
      }
      const payloadString = JSON.stringify(body);
      const payloadHash = await this.hashData(payloadString);
      let url = 'https://azsu-rg-integration-qa-apim-ecomm.azure-api.net/azsu-int-qa-func-talon-pdp/pdp-customer-create';
      if(Shopify.shop === 'the-body-shop-uk.myshopify.com') {
        url = 'https://azsu-integration-prod-apim-ecomm.azure-api.net/azsu-int-prod-func-talon-pdp/pdp-customer-create';
      }
      const pageParams = new URLSearchParams(window.location.search);
      if (pageParams.toString()) {
        url += (url.includes('?') ? '&' : '?') + pageParams.toString();
      }
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-App-Access-Token': payloadHash 
          },
          body: payloadString
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.text();
        document.querySelectorAll('.field-group').forEach((fieldGroup) => {
          fieldGroup.classList.add('is-hidden');
        })
        this.loyaltyTitle.classList.add('is-hidden');
        this.successTitle.classList.remove('is-hidden');
        this.successDescription.classList.remove('is-hidden');
        this.loyaltyDescription.classList.add('is-hidden');
        this.submitButton.disabled = true;
        this.buttonText.innerText = 'You\'re in!';
        this.saveToLocalStorage(email);
        this.pushLYBCRegistrationEvent();
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      } finally {
        this.buttonText.classList.remove('is-hidden');
        this.submitButton.classList.remove('loading');
      }
    };

    async updateCustomerInfo(email) {
      const dob = this.querySelector('input[name="dob"]')?.value;
      const body = {
        "email" : email,      
        "DateOfBirth": this.convertDateFormat(dob),
        "EmailConsent": this.acceptTermsInput ? this.acceptTermsInput.checked : false
      }
      const payloadString = JSON.stringify(body);
      const payloadHash = await this.hashData(payloadString);
      this.submitButton.disabled = true;
      this.buttonText.classList.add('is-hidden');
      this.submitButton.classList.add('loading');

      
      let url = 'https://azsu-rg-integration-qa-apim-ecomm.azure-api.net/azsu-int-qa-func-talon-pdp/pdp-customer-update-info';
      if(Shopify.shop === 'the-body-shop-uk.myshopify.com') {
        url = 'https://azsu-integration-prod-apim-ecomm.azure-api.net/azsu-int-prod-func-talon-pdp/pdp-customer-update-info';
      }
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-App-Access-Token': payloadHash 
          },
          body: payloadString
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.text();
        this.submitButton.disabled = true;
        this.saveToLocalStorage(email);
        if(this.customerNoDob) {
          this.birthdayTitle.classList.add('is-hidden');
          this.birthdayDescription.classList.add('is-hidden');
          this.birthdaySuccessTitle.classList.remove('is-hidden');
          this.birthdaySuccessDescription.classList.remove('is-hidden');
          this.buttonText.innerText = 'Submitted';

        } else {
          this.successTitle.classList.remove('is-hidden');
          this.loyaltyTitle.classList.add('is-hidden');
          this.successDescription.classList.remove('is-hidden');
          this.loyaltyDescription.classList.add('is-hidden');
          this.buttonText.innerText = 'You\'re in!';
        }
        document.querySelectorAll('.field-group').forEach((fieldGroup) => {
          fieldGroup.classList.add('is-hidden');
        })
        this.pushLYBCRegistrationEvent();

      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      } finally {
        this.submitButton.classList.remove('loading');
        this.buttonText.classList.remove('is-hidden');
      }
    };


  

    async checkCustomerStatus() {
      const email = this.querySelector('input[name="email"]').value || localStorage.getItem('loyalty_signup_email');
      const data = await this.fetchCustomerInfo(email);
      let activeStatus = data?.LYBC?.Active;
      let dob = data?.DateOfBirth;
      if (activeStatus == 'False' || activeStatus == null) {
        this.customerIsinactive = true;
      } else if (activeStatus == 'True' && dob) {
        this.classList.add('is-hidden');
        document.querySelector('.loyalty-points-guest').classList.add('is-hidden');
      } else if (activeStatus == 'True' && !dob) {
        this.customerNoDob = true;
        this.submitButton.disabled = true;
        this.buttonText.innerText = 'CELEBRATE WITH US';
        this.birthdayTitle.classList.remove('is-hidden');
        this.birthdayDescription.classList.remove('is-hidden');
        this.loyaltyTitle.classList.add('is-hidden');
        this.loyaltyDescription.classList.add('is-hidden');
        if(localStorage.getItem('form_is_submitted') && !this.dataset.customerEmail) {
          this.querySelector('input[name="email"]').value = localStorage.getItem('loyalty_signup_email');
          this.querySelector('input[name="first_name"]').value = localStorage.getItem('first_name');
          this.querySelector('input[name="last_name"]').value = localStorage.getItem('last_name');
          this.querySelector('input[name="last_name"]').disabled = true;
          this.querySelector('input[name="first_name"]').disabled = true;
          this.querySelector('input[name="email"]').disabled = true;
        }
      } else {
        console.log('Customer is not active');
      }
    }

  }
  customElements.define('loyalty-signup', LoyaltySignup);
}